import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';

// import Custom Components
import PageHeader from '../../common/page-header';
import Breadcrumb from '../../common/breadcrumb';

import { getCartTotal } from '../../../services';
import { quantityInputs, isIEBrowser } from '../../../utils';
import { changeQty, removeFromCart, changeShipping } from '../../../actions';
import { addVariantToCartlist ,removeVariantFromCartlist, removePackFromCartlist} from '../../../actions/cartlistActions';

function Cart( props ) {
    const { cartlist, total, removeFromCart, prevShip } = props;

    const [ shipping, setShipping ] = useState( prevShip );
    const shippingPrice = { "free": 0, "standard": 10, "express": 20 };

    let usercartlistvariants = props.usercartlistvariants;
    let usercartlistpacks = props.usercartlistpacks;

    let cartSellingPrice = props.cartSellingPrice;

    let user = props.user;

    useEffect( () => {
        quantityInputs();
    } )

    const dispatch = useDispatch();

    useEffect(() => {
        /*cartlist.map((item, index) => {
            if ( document.querySelector( `#quantity-input-wrapper-${index} .input-group input` ) ) {
                document.querySelector( `#quantity-input-wrapper-${index} .input-group input` ).value = item.qty;
            }
            return item;
        });*/
    }, [cartlist]);

    function onChangeShipping( val ) {
        setShipping( val );
    }

    function goToCheckout() {
        props.changeShipping( shipping );
    }

    function onRefreshQty(productId) {
        var nqty = document.getElementById('newqtty').value;
        dispatch(addVariantToCartlist( productId, nqty, true ));
    }

    function onRemoveVariantFromCart(productId) {
        dispatch(removeVariantFromCartlist(productId));
    }

    function onRemovePackFromCart(productId) {
        dispatch(removePackFromCartlist(productId));
    }

    return (
        <>
            <Helmet>
                <title>Panier</title>
            </Helmet>

            <h1 className="d-none">Panier</h1>


            <div className="main">
                <PageHeader title="Panier" subTitle="Shop" />
                <Breadcrumb title="Panier" parent1={ [ "Shop", "shop/sidebar/list" ] } />

            { user.isLogged ?

                <div className="page-content">
                    <div className="cart">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-9">
                                    <table className="table table-cart table-mobile">
                                        <thead>
                                            <tr>
                                                <th>Product</th>
                                                <th>Price</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            { usercartlistvariants.length > 0 ?
                                            <tr>Variants</tr> : '' }
                                            { usercartlistvariants.length > 0 ?
                                                usercartlistvariants.map( ( item, index ) =>
                                                    <tr key={ 'cart-item-' + index }>
                                                        <td className="product-col">
                                                            <div className="product">
                                                                <figure className="product-media">
                                                                    {/*<Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${item.id}` }>
                                                                        <img src={ process.env.REACT_APP_PUBLIC_URL + '/' + item.pictures[ 0 ] } alt="Product" />
                                                                    </Link>*/}
                                                                </figure>

                                                                <h3 className="product-title">
                                                                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${item.id}` }>{ item.variant.nameFr }</Link>
                                                                </h3>
                                                            </div>
                                                        </td>

                                                        <td className="price-col">
                                                            {
                                                                item.variant.price
                                                            } MAD
                                                        </td>

                                                        <td className="quantity-col" id={'quantity-input-wrapper-' + index} >
                                                            {/*<div className="cart-product-quantity" onClick={ ( e ) => onChangeQty( e, item.id ) }>
                                                                <input type="number"
                                                                    className="form-control"
                                                                    defaultValue={ item.qty }
                                                                    min="1"
                                                                    max={ item.stock }
                                                                    step="1"
                                                                    data-decimals="0"
                                                                    required
                                                                />
                                                            </div>*/}
                                                            <div className="details-filter-row details-row-size">
                                                                <label htmlFor="qty">Quantité:</label>
                                                                <div className="product-details-quantity" style={{marginRight: '20px'}}>
                                                                    <input type="number" id={'qty'+item.id} className="form-control" defaultValue={ item.qty } min="1" max="100" step="1" data-decimals="0" required />
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td className="total-col" style={{width: '15%'}}>
                                                            { item.qty * item.variant.price } MAD
                                                        </td>

                                                        <td className="remove-col">
                                                            <button className="btn-remove" onClick={ ()=> { onRemoveVariantFromCart( item.variant.id ) } }><i className="icon-close"></i></button>
                                                            <button className="btn-remove" onClick={ ()=> { onRefreshQty( item.variant.id ) } }><i className="icon-refresh"></i></button>
                                                        </td>
                                                    </tr>
                                                ) :
                                                <tr>
                                                    <td>
                                                        {/*<p className="pl-2 pt-1 pb-1"> No Products in Cart </p>*/}
                                                    </td>
                                                </tr>
                                            }
                                            { usercartlistpacks.length > 0 ?
                                            <tr>Packs</tr> : '' }
                                            { usercartlistpacks.length > 0 ?
                                                usercartlistpacks.map( ( item, index ) =>
                                                    <tr key={ 'cart-item-' + index }>
                                                        <td className="product-col">
                                                            <div className="product">
                                                                <figure className="product-media">
                                                                    {/*<Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${item.id}` }>
                                                                        <img src={ process.env.REACT_APP_PUBLIC_URL + '/' + item.pictures[ 0 ] } alt="Product" />
                                                                    </Link>*/}
                                                                </figure>

                                                                <h3 className="product-title">
                                                                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${item.id}` }>{ item.pack.nameFr }</Link>
                                                                </h3>
                                                            </div>
                                                        </td>

                                                        <td className="price-col">
                                                            {
                                                                item.pack.price
                                                            } MAD
                                                        </td>

                                                        <td className="quantity-col" id={'quantity-input-wrapper-' + index}>
                                                            {/*<div className="cart-product-quantity" onClick={ ( e ) => onChangeQty( e, item.id ) }>
                                                                <input type="number"
                                                                    className="form-control"
                                                                    defaultValue={ item.qty }
                                                                    min="1"
                                                                    //max={ item.stock }
                                                                    step="1"
                                                                    data-decimals="0"
                                                                    required
                                                                />
                                                            </div>*/}
                                                            <div className="details-filter-row details-row-size">
                                                                <label htmlFor="qty">Quantité:</label>
                                                                <div className="product-details-quantity" style={{marginRight: '20px'}}>
                                                                    <input type="number" className="form-control" defaultValue={ item.qty } min="1" max="100" step="1" data-decimals="0" required />
                                                                </div>
                                                            </div>
                                                        </td>

                                                        <td className="total-col">
                                                            { item.qty * item.pack.price } MAD
                                                        </td>

                                                        <td className="remove-col">
                                                            <button className="btn-remove" onClick={ ()=> { onRemovePackFromCart( item.pack.id ) } }><i className="icon-close"></i></button>
                                                            <button className="btn-remove" onClick={ ()=> { onRefreshQty( item.pack.id ) } }><i className="icon-refresh"></i></button>
                                                        </td>
                                                    </tr>
                                                ) :
                                                <tr>
                                                    <td>
                                                        {/*<p className="pl-2 pt-1 pb-1"> No Products in Cart </p>*/}
                                                    </td>
                                                </tr>
                                            }

                                        </tbody>
                                    </table>

                                    <div className="cart-bottom">
                                        {/*<div className="cart-discount" style={ { minHeight: isIEBrowser() ? '40px' : 'auto' } }>
                                            <form action="#">
                                                <div className="input-group">
                                                    <input type="text" className="form-control" required="" placeholder="coupon code" />
                                                    <div className="input-group-append">
                                                        <button className="btn btn-outline-primary-2" type="submit"><i className="icon-long-arrow-right"></i></button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>*/}

                                        {/*<button className="btn btn-outline-dark-2"><span>UPDATE CART</span><i className="icon-refresh"></i></button>*/}
                                    </div>
                                </div>
                                <aside className="col-lg-3">
                                    <div className="summary summary-cart">
                                        <h3 className="summary-title">Total du Panier</h3>

                                        <table className="table table-summary">
                                            <tbody>
                                                {/*<tr className="summary-subtotal">
                                                    <td>Subtotal:</td>
                                                    <td>${ total.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }</td>
                                                </tr>*/}
                                                {/*<tr className="summary-shipping">
                                                    <td>Livraison:</td>
                                                    <td>&nbsp;</td>
                                                </tr>

                                                <tr className="summary-shipping-row">
                                                    <td>
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio"
                                                                id="free-shipping"
                                                                name="shipping"
                                                                className="custom-control-input"
                                                                onChange={ ( e ) => onChangeShipping( "free" ) }
                                                                defaultChecked={ "free" === prevShip ? true : false }
                                                            />
                                                            <label className="custom-control-label" htmlFor="free-shipping">Livraison gratuite</label>
                                                        </div>
                                                    </td>
                                                    <td>$0.00</td>
                                                </tr>

                                                <tr className="summary-shipping-row">
                                                    <td>
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio"
                                                                id="standard-shipping"
                                                                name="shipping"
                                                                className="custom-control-input"
                                                                onChange={ ( e ) => onChangeShipping( "standard" ) }
                                                                defaultChecked={ "standard" === prevShip ? true : false }
                                                            />
                                                            <label className="custom-control-label" htmlFor="standard-shipping">Standard:</label>
                                                        </div>
                                                    </td>
                                                    <td>$10.00</td>
                                                </tr>

                                                <tr className="summary-shipping-row">
                                                    <td>
                                                        <div className="custom-control custom-radio">
                                                            <input type="radio"
                                                                id="express-shipping"
                                                                name="shipping"
                                                                className="custom-control-input"
                                                                onChange={ ( e ) => onChangeShipping( "express" ) }
                                                                defaultChecked={ "express" === prevShip ? true : false }
                                                            />
                                                            <label className="custom-control-label" htmlFor="express-shipping">Express:</label>
                                                        </div>
                                                    </td>
                                                    <td>$20.00</td>
                                                </tr>
                                                */}
                                                {/*<tr className="summary-shipping-estimate">
                                                    <td>Estimate for Your Country<br /> <a href={ `${process.env.REACT_APP_PUBLIC_URL}/shop/dashboard` }>Change address</a></td>
                                                    <td>&nbsp;</td>
                                                </tr>*/}

                                                <tr className="summary-total">
                                                    <td>Total:</td>
                                                    <td>
                                                        {/*${ ( total + shippingPrice[ shipping ] ).toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }*/}
                                                        { cartSellingPrice} MAD                                                   
                                                    </td> 
                                                </tr>
                                            </tbody>
                                        </table>

                                        <Link
                                             to={ `/shop/checkout`}
                                            className="btn btn-outline-primary-2 btn-order btn-block"
                                            onClick={ goToCheckout }>
                                            <span>Finaliser la commande</span>
                                        </Link>
                                            
                                        
                                    </div>

                                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/sidebar/list` } className="btn btn-outline-dark-2 btn-block mb-3"><span>CONTINUE SHOPPING</span><i className="icon-refresh"></i></Link>
                                </aside>
                            </div>
                        </div>
                    </div>
                </div> : 
                <div class="container" style={{textAlign: 'center', marginBottom: '5%', marginTop: '5%'}}>
                    <p style={{fontSize: '55px', fontWeight: 'bold'}}>vous devez d'abord vous connecter</p>   
                </div> 
            
            }
            </div>
        
        </>
    )
}

export const mapStateToProps = ( state ) => ( {
    usercartlistvariants: state.usercartlist.cartlist_variants ? state.usercartlist.cartlist_variants : [],
    usercartlistpacks: state.usercartlist.cartlist_packs ? state.usercartlist.cartlist_packs : [],
    user: state.user ? state.user : [],
    cartlist: state.cartlist.cart,
    total: getCartTotal( state.cartlist.cart ),
    cartSellingPrice: state.usercartlist.sellingPrice ? state.usercartlist.sellingPrice : 0,
    prevShip: state.cartlist.shipping
} )

export default connect( mapStateToProps, { addVariantToCartlist, changeQty, removeVariantFromCartlist, removePackFromCartlist, removeFromCart, changeShipping } )( Cart );